import React, { Component } from "react";
import StyledCheckbox from "../../Shared/StyledCheckbox";
import DropDownMenu from "../../Shared/DropDownMenu";
import DateFormatters from "../../../constants/DateFormatters";
import DocumentMetadataHelperService from "../../../services/DocumentSearch/DocumentMetaDataHelperService";
const { CardViewDateFormat } = DateFormatters;
const { orderedDocumentMetaData } = DocumentMetadataHelperService;

export default class DigitalCardView extends Component {
  state = {
    isChecked: false,
  };

  render() {
    const {
      doc,
      isSelected,
      _,
      viewDocument,
      downloadDocument,
      updateSelectedItems,
      viewInOmnidox,
      metaDefinitions,
      canPreviewDocument,
    } = this.props;

    const { documentMetadata } = doc;
    const previewDocument = canPreviewDocument(documentMetadata);
    const matchDataCount =
      documentMetadata["match-data"] &&
      JSON.parse(documentMetadata["match-data"])
        ? JSON.parse(documentMetadata["match-data"]).length
        : 0;

    const orderedMetaData = orderedDocumentMetaData(
      documentMetadata,
      metaDefinitions
    );
    const customFields = [
      ...orderedMetaData,
      ...[
        { name: "document-type-name", alias: _.DocumentType },
        { name: "folder-name", alias: _.FolderName },
        { name: "uploaded-date", alias: _.UploadedDate, dataType: 0 },
      ],
    ];

    return (
      <div className={"card doc-list-item" + (isSelected ? " selected" : "")}>
        <div className="doc-list-item-action-wrapper">
          {matchDataCount > 0 ? (
            <span className="match-indicator">{matchDataCount}</span>
          ) : (
            ""
          )}
          <DropDownMenu
            className="portlet-menu"
            BtnClass="portlet-menu-button"
            Items={[
              {
                Text: previewDocument ? _.ViewDocument : "Download Document",
                attr: {
                  onClick: () => {
                    if (previewDocument) {
                      viewDocument(documentMetadata);
                    } else {
                      downloadDocument(
                        documentMetadata["document-identifier"],
                        documentMetadata["original-filename"]
                      );
                    }
                  },
                },
              },
              {
                Text: _.ClientHub.ViewOnOmnidox,
                attr: {
                  onClick: () => {
                    viewInOmnidox([documentMetadata["document-identifier"]]);
                  },
                },
              },
            ]}
          />
        </div>
        <div>
          <div className="card-body-details">
            <StyledCheckbox
              checked={this.state.isChecked}
              onChange={() =>
                this.setState({ isChecked: !this.state.isChecked }, () =>
                  updateSelectedItems(
                    documentMetadata["document-identifier"],
                    this.state.isChecked
                  )
                )
              }
            />
            {doc.index}

            <div className="card-item-document-type">
              {documentMetadata["document-type-name"]}
            </div>
          </div>

          {customFields.slice(0, 3).map((field, index) => (
            <div className="card-body-details" key={index}>
              <strong className="d-inline-block w-50">{field.alias}</strong>
              <span className="d-inline-block w-50">
                {field.dataType === 0
                  ? CardViewDateFormat(
                      documentMetadata[field.name],
                      _.MomentLang
                    )
                  : documentMetadata[field.name]}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
